module.exports = __webpack_public_path__ + "f48e9ace1dc1d45df1bc29b7ad96ecf2.MP3";